<script setup>

</script>

<template>
    <tbody><slot/></tbody>
</template>

<style scoped>

</style>
